import styled from "styled-components";

export const StyledContextSwitch = styled.div`
  margin: 2rem 0 1rem 0;

  .account-switch-heading {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 1rem 0;
    padding: 0 1.4rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-top: 1px solid #f0f0f0;
    padding-top: 1rem;
  }

  .ant-segmented {
    padding: 4px;
    border-radius: 12px;
  }

  .ant-segmented-item {
    border-radius: 8px;
    padding: 8px 0px;
    color: #222222;
    font-size: 12px;
  }

  .ant-segmented-item-selected {
    border-radius: 8px;
    padding: 8px 16px;
    color: #1c1726;
    font-weight: 600;
  }
`;
